import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Show message when user tries to access protected route without authentication
    if (!loading && !isAuthenticated) {
      toast.info('Por favor, inicia sesión para acceder a esta página.');
    }
  }, [loading, isAuthenticated]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '1rem'
      }}>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
        <div>Verificando sesión...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login with the location they were trying to access
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && !isAdmin) {
    toast.error('No tienes permisos para acceder a esta página.');
    return <Navigate to="/calculator" replace />;
  }

  return children;
};

export default PrivateRoute;